export enum ApiCallStatusEnum {
    Started = 1,
    Success = 2,
    Failed = 3,
    NotStarted = 4,
}